import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.33317 3.33332C7.87293 3.33332 7.49984 3.70642 7.49984 4.16666V4.99999H12.4998V4.16666C12.4998 3.70642 12.1267 3.33332 11.6665 3.33332H8.33317ZM14.1665 4.99999V4.16666C14.1665 2.78594 13.0472 1.66666 11.6665 1.66666H8.33317C6.95246 1.66666 5.83317 2.78594 5.83317 4.16666V4.99999H4.1665C2.78579 4.99999 1.6665 6.11928 1.6665 7.49999V15C1.6665 16.3807 2.78579 17.5 4.1665 17.5H15.8332C17.2139 17.5 18.3332 16.3807 18.3332 15V7.49999C18.3332 6.11928 17.2139 4.99999 15.8332 4.99999H14.1665Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }